const LazyLoad = () => {
  return <div></div>;
};

export default LazyLoad;
